export default __webpack_public_path__ + "static/media/save.52a724ca.svg";